import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { Createtoken } from "../../../routes/cryptography";
import FileDownload from "js-file-download";
import { Buffer } from "buffer"

class CreateToken extends Component {
  constructor() {
    super();
    this.state = {
      key: "",
      pubkey: "",

      fileKeyForTokenname: "файл",
      fileKeyForTokenIsOpen: false,

      filePubKeyname: "файл",
      filePubKeyIsOpen: false,
      errors: {},
    };
    this.handleFilePubKeyChange = this.handleFilePubKeyChange.bind(this);
    this.handleFileKeyForTokenChange = this.handleFileKeyForTokenChange.bind(
      this
    );
    this.handleCreateTokenSubmit = this.handleCreateTokenSubmit.bind(this);
  }

  componentDidMount() {}

  handleFilePubKeyChange(e) {
    try {
      const file = document.getElementById("dataPubKey").files[0];
      //console.log(file);

      if (file !== undefined) {
        this.setState({ filePubKeyname: file.name, filePubKeyIsOpen: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            pubkey: data,
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({ filePubKeyname: "файл", filePubKeyIsOpen: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleFileKeyForTokenChange() {
    try {
      const file = document.getElementById("dataKeyForToken").files[0];
      //console.log(file);

      if (file !== undefined) {
        this.setState({
          fileKeyForTokenname: file.name,
          fileKeyForTokenIsOpen: true,
        });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            key: data,
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({
          fileKeyForTokenname: "файл",
          fileKeyForTokenIsOpen: false,
        });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleCreateTokenSubmit(e) {
    e.preventDefault();
    try {
      Createtoken(this.state.key, this.state.pubkey).then((res) => {
        try {
          //console.log(res);
          if (res.status === 200) {
            FileDownload(res.data.token, "token.pem");
            document.getElementById("view").style.borderColor = "green";
          } else {
            document.getElementById("view").style.borderColor = "red";
          }
        } catch (error) {
          document.getElementById("view").style.borderColor = "red";
          //console.log(error);
        }
      });
    } catch (error) {
      //console.log(error);
    }
  }

  render() {
    return (
      <div className="container">
        <h4 className="major">Установка защиты на ключ</h4>
        <Form onSubmit={this.handleCreateTokenSubmit}>
          <div className="sm-4">
            <Form.Group>
              <Form.Label>Защищаемый ключ </Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="dataKeyForToken"
                  onChange={this.handleFileKeyForTokenChange}
                  isValid={this.state.fileKeyForTokenIsOpen}
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.fileKeyForTokenname}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
              </Form.File>
            </Form.Group>

            <Form.Group>
              <Form.Label>Открытый ключ или сертификат получателя </Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="dataPubKey"
                  onChange={this.handleFilePubKeyChange}
                  isValid={this.state.filePubKeyIsOpen}
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.filePubKeyname}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
              </Form.File>
            </Form.Group>

            <Button
              style={{ float: "right" }}
              variant="success"
              type="submit"
              size="sm"
            >
              Установить защиту
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(CreateToken));
